import { Table, TableProps } from 'antd';
import { useEffect, useState } from 'react';

import LoadingComponent from 'components/loadingComponent/loadingComponent';
import OrdersFilter from '../components/filter/filter';
import TableCustomCell from '../../../components/tableCustomCell/tableCustomCell';
import dayjs from 'dayjs';

interface Order {
	id: number;
	userName: string;
	userPhone: string;
	companyName: string;
	companyId: string;
	type: 'Buy' | 'Sell';
	date: Date;
	share: number;
	amount: number;
}

function OrdersPage() {
	const [isLoading, setIsLoading] = useState(true);

	const columns: TableProps<Order>['columns'] = [
		{
			title: 'User ID',
			dataIndex: 'id',
			key: 'id',
			render: (id) => <span style={{ fontWeight: 500, color: '#3F4254' }}>{id}</span>,
		},
		{
			title: 'Company',
			dataIndex: 'companyName',
			key: 'companyName',
			render: (companyName, order) => <TableCustomCell title={order.companyName} subTitle={order.companyId} />,
		},
		{
			title: 'User',
			dataIndex: 'userName',
			key: 'userName',
			render: (_, order) => <TableCustomCell title={order.userName} subTitle={order.userPhone} />,
		},
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
			render: (type) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{type}</span>,
		},
		{
			title: 'Date',
			dataIndex: 'date',
			key: 'date',
			render: (date) => <span style={{ fontWeight: 500, color: '#7E8299' }}>{dayjs(date).format('DD MMM - HH:mm A')}</span>,
		},
		{
			title: 'Amount',
			dataIndex: '',
			key: '	',
			render: (_, order) => (
				<span style={{ fontWeight: 500, color: '#7E8299' }}>
					{order.share} Shares / {order.amount} SAR
				</span>
			),
		},
		{
			title: 'Status',
			dataIndex: '',
			key: '	',
			render: (_, order) => (
				<div className="d-flex gap-1">
					<span className="status pending">Standing</span>
					<span className="status pending">Buy</span>
					<span className="status pending">Partial</span>
				</div>
			),
		},
	];

	const data: Order[] = [
		{
			id: 1,
			userName: 'Moemen Said',
			userPhone: '01156895254',
			companyName: 'STC',
			companyId: '1234',
			date: new Date(),
			share: 50,
			amount: 2.5,
			type: 'Buy',
		},
		{
			id: 2,
			userName: 'Abanob Ramzy',
			userPhone: '01156895254',
			companyName: 'STC',
			companyId: '1234',
			date: new Date(),
			share: 50,
			amount: 2.5,
			type: 'Sell',
		},
		{
			id: 3,
			userName: 'Moemen Said',
			userPhone: '01156895254',
			companyName: 'STC',
			companyId: '1234',
			date: new Date(),
			share: 50,
			amount: 2.5,
			type: 'Buy',
		},
		{
			id: 4,
			userName: 'Abanob Ramzy',
			userPhone: '01156895254',
			companyName: 'STC',
			companyId: '1234',
			date: new Date(),
			share: 50,
			amount: 2.5,
			type: 'Sell',
		},
	];

	useEffect(() => {
		setIsLoading(true);

		setTimeout(() => {
			setIsLoading(false);
		}, 0);
	}, []);

	return (
		<>
			<div className="pageHeader">
				<h3>Current orders</h3>
				{/* <p>The most important info highlights</p> */}
			</div>

			{isLoading ? (
				<LoadingComponent />
			) : (
				<>
					<div className={`sectionContainer`}>
						<OrdersFilter />

						<Table columns={columns} dataSource={data} scroll={{ x: 400 }} />
					</div>
				</>
			)}
		</>
	);
}

export default OrdersPage;
